export interface CellAddress {
  rowIndex: number;
  columnId: string;
}

function extractAddress(cell: HTMLElement): CellAddress | null {
  const columnId = cell.dataset.columnId;
  const rowIndexStr = cell.dataset.rowIndex;
  if (!columnId || rowIndexStr === undefined) return null;

  const rowIndex = Number(rowIndexStr);
  if (Number.isNaN(rowIndex)) return null;

  return { rowIndex, columnId };
}

function findCellAt(
  clientX: number,
  clientY: number,
): { cell: HTMLElement; element: HTMLElement } | null {
  const element = document.elementFromPoint(
    clientX,
    clientY,
  ) as HTMLElement | null;
  if (!element) return null;

  const cell = element.closest("[data-column-id]") as HTMLElement | null;
  if (cell) return { cell, element };

  return null;
}

export function getCellAddressFromEvent(event: Event): CellAddress | null {
  const target = event.target as HTMLElement;
  const cell = target.closest("[data-column-id]") as HTMLElement | null;
  if (!cell) return null;

  return extractAddress(cell);
}

export function getCellAddressFromPoint(
  clientX: number,
  clientY: number,
): CellAddress | null {
  const hit = findCellAt(clientX, clientY);
  if (hit) return extractAddress(hit.cell);

  const element = document.elementFromPoint(
    clientX,
    clientY,
  ) as HTMLElement | null;
  if (!element) return null;

  const table =
    element.tagName === "TABLE" ? element : element.closest("table");
  if (!table) return null;

  const tableRect = table.getBoundingClientRect();

  const midX = (tableRect.left + tableRect.right) / 2;
  const isRight = clientX > midX;
  const hStep = isRight ? -8 : 8;

  for (
    let x = clientX + hStep;
    isRight ? x > tableRect.left : x < tableRect.right;
    x += hStep
  ) {
    const hit = findCellAt(x, clientY);
    if (hit) return extractAddress(hit.cell);
  }

  const midY = (tableRect.top + tableRect.bottom) / 2;
  const isBelow = clientY > midY;
  const vStep = isBelow ? -8 : 8;

  for (
    let y = clientY + vStep;
    isBelow ? y > tableRect.top : y < tableRect.bottom;
    y += vStep
  ) {
    const hit = findCellAt(clientX, y);
    if (hit) return extractAddress(hit.cell);
  }

  return null;
}

export function isInsideTable(target: HTMLElement): boolean {
  return target.closest("table") !== null;
}
